import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PiggdekkontrollerFilterForm from "./PiggdekkontrollFilterForm";

import {
  handleChange as handleChangeAction,
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";

import { getPiggdekkontroller as getPiggdekkontrollerAction } from "../../../actions/piggdekkontrollerActions";

import { setPage as setPageAction } from "../../../actions/advancedListActions";
import * as inputValidation from "../../../utils/inputValidationUtils";

function PiggdekkontrollFilterContainer() {
  const dispatch = useDispatch();
  const piggdekkontrollFilterFormState = useSelector(
    (state) => state.forms.piggdekkontrollFilterForm,
  );
  const piggdekkontroller = useSelector((state) => state.piggdekkontroller);

  const [showSokSpinner, setShowSokSpinner] = useState(false);

  const handleChange = (e) => {
    dispatch(
      handleChangeAction(
        "PIGGDEKKONTROLL_FILTER_FORM",
        e.target.name,
        e.target.value,
      ),
    );
  };

  const resetValidationErrorText = () => {
    dispatch(
      handleChangeAction(
        "PIGGDEKKONTROLL_FILTER_FORM",
        "fraDatoValidationErrorText",
        null,
      ),
    );
    dispatch(
      handleChangeAction(
        "PIGGDEKKONTROLL_FILTER_FORM",
        "tilDatoValidationErrorText",
        null,
      ),
    );
  };

  const validate = () => {
    return inputValidation.fraDateTimeTilDateTimeValidation(
      piggdekkontrollFilterFormState,
      (name, value) =>
        dispatch(
          handleChangeAction("PIGGDEKKONTROLL_FILTER_FORM", name, value),
        ),
    );
  };

  const handleChangeToInitState = () => {
    dispatch(handleChangeToInitStateAction("PIGGDEKKONTROLL_FILTER_FORM"));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    resetValidationErrorText();
    if (validate()) {
      dispatch(
        handleChangeAllAction("RAPPORT_PIGGDEKKONTROLLER_SUBMITTED_FORM", {
          fraDato: piggdekkontrollFilterFormState.fraDato,
          tilDato: piggdekkontrollFilterFormState.tilDato,
          submitTimestamp: new Date(),
          kjennemerke: piggdekkontrollFilterFormState.kjennemerke,
        }),
      );
      setShowSokSpinner(true);
      const page = 1;
      dispatch(
        getPiggdekkontrollerAction(
          { ...piggdekkontrollFilterFormState },
          page,
          piggdekkontroller.count,
        ),
      )
        .then(() => {
          setShowSokSpinner(false);
          dispatch(setPageAction("piggdekkontroller", page));
        })
        .catch(() => setShowSokSpinner(false));
    }
  };

  return (
    <PiggdekkontrollerFilterForm
      showSokSpinner={showSokSpinner}
      piggdekkontrollFilterFormState={piggdekkontrollFilterFormState}
      handleChange={handleChange}
      handleChangeToInitState={handleChangeToInitState}
      handleSubmit={handleSubmit}
    />
  );
}

export default PiggdekkontrollFilterContainer;
